import { z } from 'zod'
import { useTranslation } from 'react-i18next'

export interface IPhoneDataSchema {
  phoneData: {
    countryCode: string
    countryIsoCode: string
    number: string
  }
}

export const usePhoneDataSchema = () => {
  const { t } = useTranslation()

  return z.object({
    phoneData: z.object({
      countryCode: z
        .string()
        .min(1, t('api:validationErrors.required'))
        .regex(/^\+?\d+$/, 'Invalid country code'),
      countryIsoCode: z
        .string()
        .min(2, t('api:validationErrors.required'))
        .max(3, 'ISO code too long')
        .regex(/^[A-Za-z]{2,3}$/i, 'Invalid ISO code format')
        .transform((val) => val.toUpperCase()), // Normalize to uppercase
      number: z.string().min(1, t('api:validationErrors.required')),
    }),
  })
}
